import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { catchError, Observable, throwError } from 'rxjs';
import { UpgradePlanDialogComponent } from './upgrade-plan-dialog/upgrade-plan-dialog.component';
import { QuotaExceededDialogComponent } from './quota-exceeded-dialog/quota-exceeded-dialog.component';
import { OwnerType } from './paywall.models';

function paywallRoute(ownerType: OwnerType): string {
    return ownerType === 'tenant' ? '/tenant/paywall' : '/paywall';
}

export const paywallErrorInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);
    const dialog = inject(MatDialog);

    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            const ownerType: OwnerType = req.url.includes('/paywall/tenant/') ? 'tenant' : 'user';

            if (err.status === 402) {
                router.navigate([paywallRoute(ownerType)], {
                    queryParams: { feature: err.error?.feature, tab: 'plans' },
                });
            }

            if (err.status === 403 && err.error?.feature) {
                dialog.open(UpgradePlanDialogComponent, {
                    data: { feature: err.error.feature, planUuid: err.error.plan_uuid, ownerType },
                    width: '440px',
                });
            }

            if (err.status === 429 && err.error?.feature) {
                dialog.open(QuotaExceededDialogComponent, {
                    data: {
                        feature: err.error.feature,
                        resetsAt: err.error.resetsAt,
                        used: err.error.used,
                        limit: err.error.limit,
                        ownerType,
                    },
                    width: '440px',
                });
            }

            return throwError(() => err);
        }),
    );
};
